import type { WidgetApps } from '@/types'
import type { Provider, TaskName } from '@/composables/session/websocket/frames'

type AppTask = TaskName | TaskName[]

const apps: Record<WidgetApps, {
    task?: TaskName | TaskName[]
    provider?: Provider
}> = {
    'custom-page': {
        task: ['CUSTOM_PAGE', 'CUSTOM_PAGE_2'],
    },
    'transactionlink-open-banking': {
        task: 'OPEN_BANKING',
        provider: 'TRANSACTION_LINK',
    },
    'workflow-finish': {},
    'zoho-sign': {
        provider: 'ZOHO_SIGN',
        task: 'SIGNATURE',
    },
    'veriff-video-verification': {
        provider: 'VERIFF',
        task: 'VIDEO_VERIFICATION',
    },
    veriff: {
        provider: 'VERIFF',
        task: 'VERIFF',
    },
    'veriff-age-estimation': {
        provider: 'VERIFF',
        task: 'AGE_ESTIMATION',
    },
    twilio: {
        provider: 'TWILIO',
        task: 'VERIFY',
    },
    'ondato-vv': {
        provider: 'ON_DATO',
        task: 'VIDEO_VERIFICATION',
    },
    'moje-id-verification': {
        provider: 'MOJE_ID',
        task: 'ID_VERIFICATION',
    },
    'gbg-id-verification': {
        provider: 'GBG',
        task: 'ID_VERIFICATION',
    },
    'autopay-verification-payment': {
        provider: 'AUTO_PAY',
        task: 'VERIFICATION_PAYMENT',
    },
    'mobywatel-id-verification': {
        provider: 'MOBYWATEL',
        task: 'ID_VERIFICATION',
    },
    'au10tix-video-verification': {
        provider: 'AU10TIX',
        task: 'VIDEO_VERIFICATION',
    },
}

const checkTaskEquality = (appTask: AppTask, task: TaskName) => {
    if (Array.isArray(appTask)) {
        return appTask.includes(task)
    }
    return appTask === task
}

const getAppName = (task: TaskName, provider: Provider): WidgetApps | null => {
    for (const key in apps) {
        const app = apps[key as WidgetApps]
        if (app.provider === provider && checkTaskEquality(app.task || '', task)) {
            return key as WidgetApps
        }
    }
    return null
}

export default getAppName
